const taggingHelper = (eventAction, type, heading, eventLabel, url, position) => {

    let eventLabelValue
    if (type === 1) {
      eventLabelValue = `${heading} - ${eventLabel} - ${url} - Position:${position}`
    } else if (type === 2) {
      eventLabelValue = `${heading} - ${url} - Position:${position}`
    }  else if (type === 3) {
        eventLabelValue = `${heading} - ${url}`
    }
    window.dataLayer.push({
      event: 'whats_new_in_store',
      TGGEventCategory: 'Whats New',
      TGGEventAction: eventAction,
      TGGEventLabel: eventLabelValue
    })
  }
  
  export default taggingHelper